import { render } from "./FormDatePicker.vue?vue&type=template&id=23eff7ee&scoped=true"
import script from "./FormDatePicker.vue?vue&type=script&lang=js"
export * from "./FormDatePicker.vue?vue&type=script&lang=js"

import "./FormDatePicker.vue?vue&type=style&index=0&id=23eff7ee&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-23eff7ee"

export default script